//clinic-manager/report/selectReportList
import http from  './axios'

export const pregnancyAppointment = param =>{return http.post("clinic-manager/pregnancyAppointment/page",param).then(res=>res.data.data)};
//分页查询预约数据




// WEBPACK FOOTER //
// ./src/api/appointments.js